package com.taager.dukan.feature.checkout.payment

sealed interface PostPaymentSideEffect {
    object GoToHome : PostPaymentSideEffect
    object GoToProductDetails : PostPaymentSideEffect
    object ShowInternetConnectionError : PostPaymentSideEffect
    data class OpenMailTo(val email: String) : PostPaymentSideEffect
    object GoToCheckoutSuccess : PostPaymentSideEffect
}
